/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */

import {Type} from 'class-transformer';
import {BaseCollectionModel} from '@yasc/yasc-material-components';

export class FTransactionJobRes {
    autoDetectionRunning!: boolean;

    @Type(() => BaseCollectionModel<FinApiTransactionRes>)
    transactions!: BaseCollectionModel<FinApiTransactionRes>;
}

export class FinApiTransactionRes {
    id!: number;
    currency!: string;
    accountId!: number;
    valueDate!: any;
    bankBookingDate: any;
    finapiBookingDate: any;
    amount!: number;
    amountFormatted!: string;
    labels: string[] = [];
    purpose!: string;
    type!: string;
    category!: string;
    certisData!: string;
    feeAmount!: number;
    counterpartName!: string;
    counterpartAccountNumber!: string;
    booked: boolean = false;
    isRecurring: boolean = false;

    @Type(() => FinApiPaypalData)
    paypalData?: FinApiPaypalData
}

export class FinApiPaypalData {
    invoiceNumber!: string;
    fee!: number;
    net!: number;
}